(function () {
    'use strict';

    angular
        .module('huddle')
        .config(huddle);

    huddle.$inject = ['$stateProvider'];

    function huddle ($stateProvider) {
        $stateProvider
            .state('root.huddle', {
                abstract: true,
                url: '/huddle'
            })
            .state ('root.huddle.careerAdvisors', {
                url: '/career-advisors',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/huddle/reports/career-advisors/list.html',
                        controller: 'CareerAdvisorsController',
                        controllerAs: 'careerAdvisors'
                    }
                }
            });
    }
})();